// src/services/userService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

const userService = {
  // Minimal company user list — any authenticated user, not admin-only. Used for
  // "select a colleague" pickers (e.g. BOL USDA attestation marksVerifiedBy).
  listUsers: () =>
    axios.get(`${API_URL}/api/users/list`, authHeader()).then(r => r.data),
};

export default userService;
